import Image from './Image';

export default Image;
export * from './Image';
